import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const PricingContent = () => {
    const [activeButton, setActiveButton] = useState('whatsapp');
    const [isYearly, setIsYearly] = useState(false);


    const handleButtonClick = (button) => {
        setActiveButton(button);
    };

    const metrics = [
        {
            value: '95%',
            title: 'Customer Satisfaction',
            subtitle: 'Based on recent surveys',
        },
        {
            value: '30%',
            title: 'Delivery Rate Improvement',
            subtitle: 'Better than industry standard',
        },
        {
            value: '1M+',
            title: 'Messages Sent Daily',
            subtitle: 'Reliable delivery worldwide',
        },
        {
            value: '30%',
            title: 'Cost Reduction',
            subtitle: 'Average savings for clients',
        },
    ];
    const whatsapppricingplan = [
        {
            title: "Basic",
            pricemontly: "₹999",
            priceannually: "₹899",
            subtitle: "/per month - Billed Annually",
            description: "Everything you need to get started with your business.",
            conversationCharges: [
                "Marketing: ₹0.85",
                "Utility: ₹0.15",
                "Authentication: ₹0.15",
                "Service: Unlimited Free Service Conversations"
            ],
            features: [
                "Everything in Free Forever plan",
                "Unlimited agent logins",
                "Smart audience segmentation",
                "Broadcasting & retargeting tools",
                "Template message APIs",
                "Multi-agent live chat with transfer",
                "Manager monitoring",
                "API integrations",
                "Dialogflow chatbot integration",
                "Shared team inbox",
                "Click-to-WhatsApp ads manager",
                "Chatbot Flows: 5 flows @ ₹ 1999 (charged separately)"
            ]
        },
        {
            title: "Pro",
            pricemontly: "₹2499",
            priceannually: "₹2159",
            subtitle: "/per month - Billed Annually",
            description: "Highly recommended plan to make the best use of Retargeting Campaigns",
            conversationCharges: [
                "Marketing: ₹0.85",
                "Utility: ₹0.15",
                "Authentication: ₹0.15",
                "Service: Unlimited Free Service Conversations"
            ],
            features: [
                "Up to 100 tags",
                "20 custom attributes",
                "Campaign scheduler & click tracking",
                "Smart agent routing",
                "Campaign budget analytics",
                "Project APIs",
                "Carousel template clicks tracking",
                "CSV campaign scheduler",
                "User access control",
                "Birthday message automation",
                "Auto retry for failed messages",
                "Chatbot Flows: 5 flows @ ₹ 1999 (charged separately)"
            ]
        },
        {
            title: "Enterprise",
            price: "Custom Pricing",
            subtitle: "Contact for pricing details & Custom Volume",
            description: "Recommended for 5 Lac+ Messages per month",
            conversationCharges: [],
            features: [
                "All features in Pro Plan",
                "Recommended for Brands with 5 Lac+ Users",
                "Unlimited Tags",
                "Unlimited Attributes",
                "Downloadable Reports",
                "Dedicated Account Manager",
                "Priority Customer Support",
                "Webhooks",
                "Higher Messaging Speed",

            ]
        }
    ];
    const [billingToggles, setBillingToggles] = useState(
        whatsapppricingplan.map(() => false) // default all to false (monthly)
    );
    const bulksmspricing = [
        {
            title: "Starter",
            price: "₹8000",
            subtitle: "/₹ 0.16 per message     Min. 50,000 - CREDT",
            description: "Everything you need to get started with your business.",
            features: [
                "50,000 SMS per month",
                "DLT Registration Support",
                "API Integrations",
                "Real-time Delivery",
                "24/7 Email Support",
                "Analytics Dashboard",
                "Web Panel Access",
                "DLT Scrubbing Included"
            ]
        },
        {
            title: "Growth",
            price: "₹14000",
            subtitle: "₹ 0.14 per message            Min. 100,000 - CREDT",
            description: "Highly recommended plan to make the best use of Retargeting Campaigns",

            features: [
                "100,000 SMS per month",
                "All Starter features",
                "24/7 Email and Phone Support",
                "Priority Support",
                "Advanced Analytics",
                "Custom Integration Support",
                "Enhanced API Access",
                "DLT Scrubbing Included"
            ]
        },
        {
            title: "Enterprise",
            price: "₹60000",
            subtitle: "₹ 0.12 per message            Min. 500,000 - CREDT",
            description: "Recommended for 5 Lac+ Messages per month",
            features: [
                "500,000 SMS per month",
                "All Growth features",
                "Dedicated Manager",
                "Custom Solutions",
                "Premium API Access",
                "Advanced Analytics",
                "Volume Pricing",
                "DLT Scrubbing Included"

            ]
        }
    ];
    const rcssmspricing = [
        {
            title: "Starter",
            price: "Min. 50,000 credit ",
            description: "Rich Communication Services",
            freemessage: "Free: 2,500 messages on first campaign",

            messagetype: [
                "Basic RBM Message₹0.21",
                "Single RBM Message₹0.27",
                "A2P - Conversational RBM Message₹0.38",
                "P2A - Conversational RBM Message₹0.19"
            ],
            othercharges: [
                "Carrier Maintenance Charge Discounted",
                "One Time Setup Discounted",
                "Platform Processing Fee Included"
            ],
            feature: [
                "50000 SMS Volume",
                "Rich Media Support",
                "Interactive Buttons",
                "Delivery Reports",
                "Basic Analytics",
                "Email Support",
                "API Access",
                "Basic Templates"
            ]
        },
        {
            title: "Growth",
            price: "Min. 100,000 credit ",
            description: "Enhanced RCS capabilities",
            freemessage: "Free: 5,000 messages on first campaign",

            messagetype: [
                "Basic RBM Message₹0.20",
                "Single RBM Message₹0.25",
                "A2P - Conversational RBM Message₹0.37",
                "P2A - Conversational RBM Message₹0.17"
            ],
            othercharges: [
                "Carrier Maintenance Charge Discounted",
                "One Time Setup Discounted",
                "Platform Processing Fee Included"
            ],
            feature: [
                "100000 SMS Volume",
                "Advanced Rich Media",
                "Custom Interactive Elements",
                "Priority Delivery",
                "Advanced Analytics",
                "Priority Support",
                "Enhanced API Access",
                "Custom Templates",
            ]
        },
        {
            title: "Enterprise",
            price: "Min. 500,000 credit",
            description: "Large-scale RCS messaging",
            messagetype: ["Basic RBM Message₹0.18",
                "Single RBM Message₹0.24",
                "A2P - Conversational RBM Message₹0.35",
                "P2A - Conversational RBM Message₹0.18"],
            othercharges: [
                "Carrier Maintenance Charge Discounted",
                "One Time Setup Discounted",
                "Platform Processing Fee Included"
            ],
            feature: [
                "500000 SMS Volume",
                "Premium Rich Media",
                "Advanced Interactive Elements",
                "Priority Delivery",
                "Enterprise Analytics",
                "24/7 Priority Support",
                "Premium API Access",
                "Custom Templates"

            ]
        }
    ];
    const seoplan = [
        {
            title: "Growth Plan",
            price: "₹50,000 for 6 months",
            CoreFeatures: ["15 - 25 Local + Regional Keywords",
                "Includes Basic Plan Features",
                "Competitor Keyword Research",
                "Technical SEO Fixes",
                "Monthly Backlink Building 1500",
                "4 Blog Posts/Month",
                "Internal Linking Strategy",
                "Google Analytics & Search Console Setup",
                "Monthly Performance Report",
            ],
        },
        {
            title: "Business Plan",
            price: "₹1,00,000 /Annual",
            CoreFeatures: ["30 - 50 Keywords",
                "All Growth Plan Features Included",
                "eCommerce SEO: Product Schema, Category Optimization",
                "Advanced Technical SEO Audit",
                "High-Authority Link Building",
                "Keyword Clustering & Funnel Optimization",
                "Weekly Keyword Tracking Report",
                "4 Blog Posts/Month",
                "Dedicated SEO Manager",
                "Monthly Backlink Building 2000",
            ],
        },

    ];
    const addOns = [
        { service: "WhatsApp API Setup & Blue Tick", price: "₹5,000 (one-time)" },
        { service: "DLT Registration for SMS", price: "₹5,999/- (one time)" }
    ];

    return (
        <div className='margin-topall'>
            <section className='pt-5 overflow-hidden'>
                <div className='container'>
                    <div className='pricingbanner' data-aos="zoom-in" data-aos-delay="300">
                        <h1>Results we've helped our clients achieve </h1>
                    </div>
                </div>
                <div className='container '>
                    <div className="row justify-content-center pricingcard">
                        {metrics.map((metric, index) => (
                            <div key={index} className="col-6 col-md-3 mb-4" data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300">
                                <div
                                    className="rounded-circle border border-dark bg-danger text-white d-flex align-items-center justify-content-center mx-auto"
                                    style={{ width: '80px', height: '80px', fontWeight: 'bold', fontSize: '18px' }}
                                >
                                    {metric.value}
                                </div>
                                <h6 className="fw-bold mt-3 text-center">{metric.title}</h6>
                                <p className="text-center">{metric.subtitle}</p>
                            </div>
                        ))}
                    </div>
                    <div className="mt-5 text-center simplefont">
                        <h5 className="fw-bold simplehead" data-aos="fade-left" data-aos-delay="300">Simple, Transparent Pricing</h5>
                        <p data-aos="fade-right" data-aos-delay="300">Choose the perfect plan for your communication need</p>
                    </div>
                </div>
            </section>
            <section className='overflow-hidden'>
                <div className="container my-5">
                    <div className="d-flex justify-content-center mb-4 gap-3">
                        <button
                            className={`btn ${activeButton === 'whatsapp' ? 'btn-danger' : 'btn-outline-dark'} px-4`}
                            onClick={() => handleButtonClick('whatsapp')}
                            data-aos="fade-up-right"  data-aos-delay="300">
                            WhatsApp
                        </button>
                        <button
                            className={`btn ${activeButton === 'bulkSms' ? 'btn-danger' : 'btn-outline-dark'} px-4`}
                            onClick={() => handleButtonClick('bulkSms')}
                            data-aos="fade-up-left"  data-aos-delay="300">
                            Bulk SMS
                        </button>
                        <button
                            className={`btn ${activeButton === 'rcsSms' ? 'btn-danger' : 'btn-outline-dark'} px-4`}
                            onClick={() => handleButtonClick('rcsSms')}
                            data-aos="fade-up-right"  data-aos-delay="300">
                            RCS SMS
                        </button>
                    </div>
                    {activeButton === "whatsapp" && (
                        <div className="row g-4 py-5">
                            {whatsapppricingplan.map((plan, index) => (
                                <div
                                    className="col-md-4"
                                    key={index}
                                    data-aos={`flip-${index % 2 === 1 ? "right" : "left"}`}
                                     data-aos-delay="300"
                                >
                                    <div className="border planrounded border-danger rounded-4 p-4 h-100">
                                        <h4
                                            className="text-center"
                                            data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}
                                             data-aos-delay="300"
                                        >
                                            {plan.title}
                                        </h4>

                                        <p
                                            className="text-center"
                                            data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}
                                             data-aos-delay="300"
                                        >
                                            {plan.description}
                                        </p>

                                        <div className="text-center" data-aos="fade-left"  data-aos-delay="300">
                                            {(index === 0 || index === 1) ? (
                                                <>
                                                    {/* Toggle switch for Monthly/Annually */}
                                                    <div
                                                        className="d-flex justify-content-center align-items-center gap-3 mb-3"
                                                        data-aos="fade-right"
                                                         data-aos-delay="300"
                                                    >
                                                        <span className={!billingToggles[index] ? 'fw-bold' : ''}>Bill Monthly</span>
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`billingToggleannually-${index}`}
                                                                checked={billingToggles[index]}
                                                                onChange={() => {
                                                                    const newToggles = [...billingToggles];
                                                                    newToggles[index] = !newToggles[index];
                                                                    setBillingToggles(newToggles);
                                                                }}
                                                            />
                                                        </div>
                                                        <span className={billingToggles[index] ? 'fw-bold' : ''}>Billed Annually</span>
                                                    </div>

                                                    {/* Pricing based on toggle */}
                                                    <h2 className="fw-bold text-danger">
                                                        {billingToggles[index] ? plan.priceannually : plan.pricemontly}
                                                    </h2>
                                                </>
                                            ) : (
                                                // Show only price for index 2
                                                <div>
                                                    <h2 className="fw-bold">{plan.price}</h2>
                                                    <p>{plan.subtitle}</p>
                                                </div>
                                            )}


                                        </div>

                                        {index !== whatsapppricingplan.length - 1 && (
                                            <Link to="/contact_us">
                                                <div
                                                    className="text-center my-2"
                                                    data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}
                                                     data-aos-delay="300"
                                                >
                                                    <button className="btn btn-danger">Get Contact</button>
                                                </div>
                                            </Link>
                                        )}

                                        {plan.conversationCharges.length > 0 && (
                                            <>
                                                <h6 className="mt-4 fs-5">Conversation Charges</h6>
                                                <ul >
                                                    {plan.conversationCharges.map((item, i) => (
                                                        <li
                                                            key={i}
                                                            data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`}
                                                             data-aos-delay="300"
                                                            className='conversationfont'
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        )}

                                        <h6
                                            className="fs-5"
                                            data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}
                                            data-aos-delay="300"
                                        >
                                            Features
                                        </h6>
                                        <ul>
                                            {plan.features.map((feature, i) => (
                                                <li
                                                    key={i}

                                                    data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`}
                                                    data-aos-delay="300"
                                                    className={`conversationfont ${i===11?"charge_separate":""}`}
                                                >
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeButton === "bulkSms" && (
                        <div className="row g-4 py-5">
                            {bulksmspricing.map((plan, index) => (
                                <div className="col-md-4" key={index} data-aos={`flip-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">
                                    <div className="border planrounded border-danger rounded-4 p-4 h-100">
                                        <h4 className="text-center" data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{plan.title}</h4>
                                        <p className="text-center" data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">{plan.description}</p>
                                        <h3 className="text-center" data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`}  data-aos-delay="300">
                                            {plan.price}
                                        </h3>
                                        <h4 className="fs-6" data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300"> {plan.subtitle}</h4>
                                        <Link to="/contact_us">
                                            <div className="text-center my-2" data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">
                                                <button className="btn btn-danger">Get Contact</button>
                                            </div>
                                        </Link>

                                        <h6 className='fs-5' data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">Features</h6>
                                        <ul>
                                            {plan.features.map((feature, i) => (
                                                <li key={i} className='conversationfont' data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    {activeButton === "rcsSms" && Array.isArray(rcssmspricing) && (
                        <div className="row g-4 py-5">
                            {rcssmspricing.map((plan, index) => (
                                <div className="col-md-4" key={index} data-aos={`flip-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">
                                    <div className="border planrounded border-danger rounded-4 p-4 h-100">
                                        <h4 className="text-center className='fs-5'" data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{plan.title}</h4>
                                        <p className="text-center" data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">{plan.description}</p>
                                        <h3 className="text-center" data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{plan.price}</h3>
                                        <h4 className="fs-6 text-center" data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`}  data-aos-delay="300">{plan.subtitle}</h4>
                                        <Link to="/contact_us">
                                            <div className="text-center my-2">
                                                <button className="btn btn-danger" data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">Get Contact</button>
                                            </div>
                                        </Link>

                                        <h6 className='fs-5' data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">Free Messages</h6>
                                        <p data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{plan.freemessage}</p>

                                        <h6 className='fs-5' data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`}  data-aos-delay="300">Message Types & Pricing</h6>
                                        <ul>
                                            {plan.messagetype.map((message, i) => (
                                                <li key={i} className='conversationfont' data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{message}</li>
                                            ))}
                                        </ul>

                                        <h6 className='fs-5' data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">Other Charges</h6>
                                        <ul>
                                            {plan.othercharges.map((charge, i) => (
                                                <li key={i} className='conversationfont' data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`}  data-aos-delay="300">{charge}</li>
                                            ))}
                                        </ul>

                                        <h6 className='fs-5' data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">Features</h6>
                                        <ul>
                                            {plan.feature.map((feature, i) => (
                                                <li key={i} className='conversationfont' data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            </section>
            <section className='overflow-hidden'>
                <div className="container ">
                    <div className="text-center mb-4" data-aos={"fade-left"}  data-aos-delay="300">
                        <h3 className="fw-bold">No-code WhatsApp Chatbot</h3>
                        <p className="lead">Get Started with Drag & Drop Chatbot Flow Builder</p>
                    </div>
                    <div className='container'>
                        <div className="row border border-danger rounded-4  planrounded">
                            {/* Left Column */}
                            <div className="col-md-4 p-4 borderbill">
                                <div className="d-flex justify-content-center align-items-center gap-3 mb-3" data-aos={"fade-right"}  data-aos-delay="300" >
                                    <span className={isYearly ? '' : 'fw-bold'}>Bill Monthly</span>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="billingToggle"
                                            checked={isYearly}
                                            onChange={() => setIsYearly(!isYearly)}
                                        />
                                    </div>
                                    <span className={isYearly ? 'fw-bold' : ''}>Billed Yearly</span>
                                </div>

                                <div className="text-center" data-aos={"fade-left"}  data-aos-delay="300">
                                    {isYearly === false && (
                                        <h2 className="fw-bold text-danger">
                                            ₹1999
                                        </h2>
                                    )}
                                    {isYearly === true && (
                                        <h2 className="fw-bold text-danger">
                                            ₹1799
                                        </h2>
                                    )}
                                    <p>Per Month - Per month (for 12 months)</p>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="col-md-8 p-4  mt-4 mt-md-0" data-aos={"fade-left"}  data-aos-delay="300">
                                <h5 className="fw-bold mb-3 text-center">WhatsApp Chatbot Flow Builder</h5>
                                <p className="mb-2 text-center mb-2"><strong>5 WhatsApp Chatbots per month</strong></p>
                                <div className='row gap-2'>
                                    <div className='col-md-6 col-lg-6'>
                                        <ul className="">
                                            <li> 5 Chatbot Flows - Build 5 unique Chatbots</li>
                                            <li> Manage Catalogues</li>
                                        </ul>
                                    </div>
                                    <div className='col-md-6 col-lg-5'>
                                        <ul>
                                            <li> Connect WhatsApp Payments with Chatbot</li>
                                            <li> Automate Sales & Support seamlessly</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='overflow-hidden'>
                <div className='container py-5'>
                    <div >
                        <h1 data-aos={"fade-up-left"}  data-aos-delay="300" className='text_yellow'>
                            Social Media Management Support Services Plan
                        </h1>
                        <p className="lead" data-aos={"fade-up-right"}  data-aos-delay="300">
                            Boost your brand’s online presence with expert social media management across major platforms. We create, manage, and grow your digital voice using customized strategies and engaging content.
                        </p>
                    </div>
                   
                </div>
            </section>
            <section className='overflow-hidden'>
                <div className="container mb-5">
                   <div className="row g-4 flex justify-content-center">
                        <div className="col-md-4" data-aos={"flip-down"}  data-aos-delay="300">
                            <div className="border border-danger planrounded rounded-4 p-4 h-100">
                                <h4 className="text-center fw-bold" data-aos={"fade-up"}  data-aos-delay="300">Growth Plan</h4>
                                <p className="text-center fw-semibold py-3" data-aos={"fade-left"}  data-aos-delay="300">₹ 6,999/month</p>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-down"}  data-aos-delay="300">Platforms & Content</h6>
                                <ul data-aos={"fade-up"}  data-aos-delay="300">
                                    <li className='conversationfont'>
                                        Facebook, Instagram
                                    </li>
                                    <li className='conversationfont'>
                                        4 custom posts monthly
                                    </li>
                                </ul>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-down"}  data-aos-delay="300">Campaigns </h6>
                                <ul data-aos={"fade-up"}  data-aos-delay="300">

                                    <li className='conversationfont'>4 monthly paid ad campaigns</li>
                                    <li className='conversationfont'>
                                        Lead generation, traffic, engagement focus
                                    </li>

                                </ul>


                                <p className=" mt-3" data-aos={"fade-down"}  data-aos-delay="300">
                                    <span className="fw-semibold">Note:</span> Ad spend is separate, managed directly by clients.
                                </p>

                            </div>
                        </div>
                        <div className="col-md-4" data-aos={"flip-up"}  data-aos-delay="300">
                            <div className="border border-danger planrounded rounded-4 p-4 h-100">
                                <h4 className="text-center fw-bold" data-aos={"fade-up"}  data-aos-delay="300"> Business Plan</h4>
                                <p className="text-center fw-semibold py-3" data-aos={"fade-down"}  data-aos-delay="300">₹11,999/month</p>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up-left"}  data-aos-delay="300">Multi-Platform Management</h6>
                                <p className='conversationfont' data-aos={"fade-up-right"}  data-aos-delay="300">
                                    Facebook, Instagram, YouTube
                                </p>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up"}  data-aos-delay="300">Rich Content Creation </h6>
                                <p className='conversationfont' data-aos={"fade-down"}  data-aos-delay="300">
                                    8 posts monthly
                                </p>
                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up"}  data-aos-delay="300">Campaigns </h6>
                                <ul data-aos={"fade-up-left"}  data-aos-delay="300">

                                    <li className='conversationfont'>4 monthly paid ad campaigns</li>
                                    <li className='conversationfont'>
                                        Leads, site purchases and engagement optimization
                                    </li>

                                </ul>

                                <p className=" mt-3" data-aos={"fade-down"}  data-aos-delay="300">
                                    <span className="fw-semibold">Note:</span> Ad spend is separate, managed directly by clients.
                                </p>

                            </div>
                        </div>

                    </div>
                </div>

            </section>
            <section className='overflow-hidden'>
                <div className='container'>
                    <h1 data-aos={"fade-up"}  data-aos-delay="1300" className='text_yellow'>
                        SEO Management Plans
                    </h1>
                    <div className="row g-4 py-5 flex justify-content-center">
                        {seoplan.map((plan, index) => (
                            <div className="col-md-4" key={index} data-aos={`flip-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">
                                <div className="border planrounded border-danger rounded-4 p-4 h-100">
                                    <h4 className="text-center" data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{plan.title}</h4>
                                    <p className="text-center py-3" data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`}  data-aos-delay="300">{plan.price}</p>
                                    <h6 className='fs-5' data-aos={`zoom-${index % 2 === 1 ? "in" : "out"}`}  data-aos-delay="300">Core Features</h6>
                                    <ul>
                                        {plan.CoreFeatures.map((feature, i) => (
                                            <li className='conversationfont' key={i} data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`}  data-aos-delay="300">{feature}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='overflow-hidden'>
                <div className='container'>
                    <h1 className='py-3 text_yellow' data-aos={"fade-up"}  data-aos-delay="300">
                      PPC: Google Ads Plans by SMS ZOO ZOO
                    </h1>
                    
                    <div className="row g-4 py-5 flex justify-content-center">
                        <div className="col-md-4" >
                            <div className="border border-danger planrounded rounded-4 p-4 h-100">
                                <h4 className="text-center fw-bold" data-aos={"fade-up"}  data-aos-delay="300">Growth Plan</h4>
                                <p className="text-center fw-semibold py-3" data-aos={"fade-down"}  data-aos-delay="300">₹ 6,999/month</p>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up-left"}  data-aos-delay="300">Support</h6>
                                <ul className='conversationfont' data-aos={"fade-up-right"}  data-aos-delay="300">
                                    <li>
                                        Weekly Optimisation
                                    </li>
                                    <li>
                                        Monthly Strategy Call
                                    </li>
                                </ul>
                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up"}  data-aos-delay="300">Enhanced Features</h6>
                                <ul className='conversationfont' data-aos={"fade-down"}  data-aos-delay="300">
                                    <li>
                                        Up to 3 Campaign
                                    </li>
                                    <li>
                                        Types: Search, Display, Remarketing
                                    </li>
                                    <li>
                                        15 - 25 Keywords
                                    </li>
                                    <li>
                                        Audience Setup
                                    </li>
                                    <li>
                                        Conversion Tracking
                                    </li>
                                    <li>
                                        A/B Testing
                                    </li>
                                </ul>


                                <p className=" mt-3" data-aos={"fade-down"}  data-aos-delay="300">
                                    <span className="fw-semibold">Note:</span> Ad spend is separate, managed directly by clients
                                </p>

                            </div>
                        </div>
                        <div className="col-md-4" data-aos={"fade-up"}  data-aos-delay="300">
                            <div className="border border-danger planrounded rounded-4 p-4 h-100">
                                <h4 className="text-center fw-bold" data-aos={"fade-down"}  data-aos-delay="300">Business Plan</h4>
                                <p className="text-center fw-semibold py-3" data-aos={"fade-left"}  data-aos-delay="300">₹11,999/month</p>

                                <h6 className="fw-bold mt-3 fs-5" data-aos={"fade-up-left"}  data-aos-delay="300">Management</h6>
                                <ul className='conversationfont' data-aos={"fade-up"}  data-aos-delay="300">
                                    <li>
                                        Daily Monitoring
                                    </li>
                                    <li>
                                        Dedicated Account Manager
                                    </li>
                                </ul>
                                <h6 className="fw-bold mt-3 fs-5">Plan Highlights</h6>
                                <ul className='conversationfont'>
                                    <li>
                                        Unlimited Campaign
                                    </li>
                                    <li>
                                        Types (Search, Display, Shopping, YouTube)
                                    </li>
                                    <li>
                                        Dynamic Remarketing + Retargeting
                                    </li>
                                    <li>
                                        Google Shopping Setup
                                    </li>
                                    <li>
                                        Advanced Bid & Budget Control
                                    </li>
                                    <li>
                                        Video Ads (YouTube)
                                    </li>
                                </ul>


                                <p className=" mt-3" data-aos={"fade-up"}  data-aos-delay="300">
                                    <span className="fw-semibold">Note:</span>Ad spend is separate, managed directly by clients
                                </p>

                            </div>
                        </div>
                    </div>


                </div>
            </section>

            <section className='overflow-hidden'>
                <div className="container paddingadd">
                    <h5 className="fw-bold py-3" data-aos="fade-left"  data-aos-delay="300">Add-Ons (Optional)</h5>
                    <div className="border border-danger planrounded rounded-4 p-3">
                        <div className="row fw-bold pb-2 mb-2" data-aos="fade-up"  data-aos-delay="300">
                            <div className="col-7 fs-5">Service</div>
                            <div className="col-5 fs-5 text-start">Price (One-Time)</div>
                        </div>
                        <div className="row py-2" data-aos="fade-down"  data-aos-delay="300">
                            <div className="col-7">WhatsApp API Setup &amp; Blue Tick</div>
                            <div className="col-5 text-start">₹5,000 (one-time)</div>
                        </div>
                        <div className="row py-2" data-aos="fade-up"  data-aos-delay="300">
                            <div className="col-7">DLT Registration for SMS</div>
                            <div className="col-5 text-start">₹5,999/- (one time)</div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default PricingContent
